import { isEmpty } from 'lodash';
import { Validate } from 'react-hook-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FieldRules = Record<string, Validate<any, any> | string | ((value: any) => string | boolean)>;

// Helper function to convert mixed rules to proper react-hook-form validate format
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getValidationRules(rules: FieldRules): Record<string, Validate<any, any>> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const validationRules: Record<string, Validate<any, any>> = {};

    Object.entries(rules).forEach(([key, value]) => {
        if (typeof value === 'function') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validationRules[key] = value as Validate<any, any>;
        } else if (typeof value === 'string') {
            // Convert string rules to validation functions that return the string as error message
            validationRules[key] = () => value;
        }
    });

    return validationRules;
}

export default function composeRules(required?: boolean, theRules: FieldRules = {}) {
    let rules: FieldRules = { ...theRules };
    if (required) {
        rules = {
            ...rules,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            required: (val: any) => {
                return !isEmpty(val) ? true : 'Ce champ est requis.';
            },
        };
    }
    return rules;
}
export function composeRules2(props: { rules?: FieldRules; min?: number; label?: string; name?: string }) {
    let rules: FieldRules = { ...(props.rules ?? {}) };
    if (props.min) {
        rules = {
            ...rules,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            min: (val: any) => {
                return val.length < props.min!
                    ? `Votre ${props?.label || props?.name?.replace('_', ' ')}  doit contenir au minimum 50 caractères.`
                    : true;
            },
        };
    }
    return rules;
}
